import { render, staticRenderFns } from "./pieCharts.vue?vue&type=template&id=8a84c6e0&scoped=true"
import script from "./pieCharts.vue?vue&type=script&lang=js"
export * from "./pieCharts.vue?vue&type=script&lang=js"
import style0 from "./pieCharts.vue?vue&type=style&index=0&id=8a84c6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84c6e0",
  null
  
)

export default component.exports